//import { stat } from "fs";
import { chatSocketReducerStateModel } from "../../models/model";
import {actionTypes} from '../action/action';
const initialState=  {
  messageList: [],
  filesAttach:[],
  fileUploadingStatus:false,
  archiveID:"",
  scrollPos:0,
  messageLoading:false,
  progressComplete: false,
  fileTextMessage:"",
  fileTexttype:0,
  isEmojiWindow:false,
  messageExtraList:[]
    };
    export const chatSocketReducerState = (state: chatSocketReducerStateModel = initialState, action: any) => {
      switch (action.type) {
      case actionTypes.MESSAGE_LIST:
        return {
          ...state, messageList: action.payload.messageList, 
          messageLoading: action.payload.messageLoading,
          fileUploadingStatus:action.payload.fileUploadingStatus,
          archiveID: action.payload.archiveID? action.payload.archiveID:"",
          scrollPos: action.payload.scrollPos ? action.payload.scrollPos:0
        };
        case actionTypes.PROGRESS_COMPLETE:
        return {
          ...state, progressComplete: action.payload.progressComplete
        };
        case actionTypes.MESSAGE_LOADING:
          return {
            ...state, messageLoading:action.payload.messageLoading
          }
          case actionTypes.SCROLL_POS:
            return {
              ...state, scrollPos:action.payload.scrollPos
            }
        case actionTypes.UPDATE_ARCHIVEID:
          return {
            ...state, archiveID: action.payload.archiveID, scrollPos:action.payload.scrollPos,
            messageLoading: action.payload.messageLoading
          };

        case actionTypes.FILE_ATTACHMENTS:
          return{
            ...state, filesAttach:action.payload.filesAttach, fileUploadingStatus:action.payload.fileUploadingStatus
          };
          case actionTypes.FILE_TEXT_MESSAGE:
            return {
              ...state, fileTextMessage:action.payload.fileTextMessage,fileTexttype:action.payload.fileTexttype
            }
            case actionTypes.EMOJI_WINDOW:
              return {
                ...state, isEmojiWindow:action.payload.isEmojiWindow
              }
              case actionTypes.MESSAGE_EXTRALIST:
                return {
                  ...state, messageExtraList:action.payload.messageExtraList
                }
              
      default:
        return state;
      }
    };
    